<footer class="site-footer">
  <div class="footer-inner">
    <img src="/logo/acacia_brown_logo.webp" alt="Acacia" class="footer-brand-logo" />
    <img src="/backgrounds/twig.webp" alt="" class="footer-twig" aria-hidden="true" />

    <div class="footer-contacts">
      <p class="footer-contacts-label">Contacts</p>
      <p class="footer-contact-item">0113111888</p>
      <a class="footer-contact-item footer-contact-email" href="mailto:sales@acacia.ke">sales@acacia.ke</a>
    </div>

    <div class="footer-disclaimer-block">
      <p class="footer-disclaimer-label">Disclaimer</p>
      <p class="footer-disclaimer">
        The information, details, and images contained in this website are provided for illustrative
        purposes only and are subject to change without prior notice. This website does not constitute
        a contract, offer, or warranty of any kind. Prospective purchasers are strongly advised to verify
        all specifications and details directly with the developer and to seek independent legal and
        financial advice before entering into any agreement or commitment.
      </p>
    </div>

    <p class="footer-powered-by">Powered by</p>
    <a
      class="footer-karim-link"
      href="https://www.karimcgvisuals.com"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Visit Karim CG Visuals"
    >
      <img src="/logo/karim_logo.webp" alt="Karim CG Visuals" class="footer-karim-logo" />
    </a>
  </div>
</footer>
